// extracted by mini-css-extract-plugin
export default {"item":"Contact_item__5++mT"};